import type { SVGProps } from 'react';

const SvgNavigationSms = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" {...props}>
    <g fill={props.color}>
      <path d="M10.5 5.6a.7.7 0 0 1-.7.7H4.2a.7.7 0 1 1 0-1.4h5.6a.7.7 0 0 1 .7.7M7.7 9.1a.7.7 0 1 0 0-1.4H4.2a.7.7 0 1 0 0 1.4z" />
      <path
        fillRule="evenodd"
        d="M0 7a7 7 0 0 1 14 0c0 1.075-.284 2.079-.7 2.96v3.34H9.96c-.881.416-1.885.7-2.96.7a7 7 0 0 1-7-7m7-5.6a5.6 5.6 0 0 0 0 11.2c.875 0 1.719-.244 2.488-.627l.148-.073H11.9V9.636l.073-.148c.382-.769.627-1.613.627-2.488A5.6 5.6 0 0 0 7 1.4"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export default SvgNavigationSms;
